import {classNames} from '@cohort/shared-frontend/utils/classNames';
import TrackableExternalLink from '@cohort/wallet/components/tracking/TrackableExternalLink';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {TrackingConfig} from '@cohort/wallet/lib/Tracking';
import {getCohortTosUrl} from '@cohort/wallet/lib/Utils';
import React from 'react';
import {useTranslation} from 'react-i18next';

export const Footer = (): React.ReactElement => {
  const {t} = useTranslation('components', {keyPrefix: 'footer'});

  const {backgroundColor, hasDarkBg} = useThemeContext();

  const navigation = [
    {
      name: t('linkPrivacy'),
      href: 'https://getcohort.com/privacy-policy',
      tracking: {
        namespace: 'footer.privacy',
      },
    },
    {
      name: t('linkTerms'),
      href: getCohortTosUrl(),
      tracking: {
        namespace: 'footer.terms',
      },
    },
  ];

  return (
    <footer
      className={classNames('border-t', hasDarkBg ? 'border-white/20 ' : 'border-black/20')}
      style={{backgroundColor}}
    >
      <div className="flex flex-col justify-between px-4 pt-5 md:flex-row md:pb-5">
        <TrackableExternalLink
          key={'linkbrand'}
          href={'https://cohort.xyz/'}
          target="_blank"
          rel="noopener noreferrer"
          tracking={{
            namespace: 'footer.brand',
          }}
          className={` ${
            hasDarkBg ? 'text-white/40 hover:text-white/90' : 'text-black/50 hover:text-black/90'
          } py-2 text-sm`}
        >
          {t('signature')}
        </TrackableExternalLink>

        <div className="flex flex-col md:flex-row md:space-x-6">
          {navigation.map(item => (
            <TrackableExternalLink
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`py-2 text-sm md:text-right ${
                hasDarkBg
                  ? 'text-white/50 hover:text-white/90'
                  : 'text-black/50 hover:text-black/90'
              }`}
              tracking={item.tracking as TrackingConfig}
            >
              {item.name}
            </TrackableExternalLink>
          ))}
        </div>
      </div>
    </footer>
  );
};
Footer.displayName = 'FooterInPage';
